import React from 'react'
import Head from 'next/head'
import { Config } from '@chegg-wt/core/config'
import { sanitizeHtmlWithFilter } from '@chegg-wt/core/utils/contentFilters'
import { routeToHref } from '@chegg-wt/core/utils/routes'
import { BreadcrumbPart } from '../Breadcrumbs'

interface BreadcrumbDataProps {
  breadcrumbs: BreadcrumbPart[]
}

const BreadcrumbData: React.FC<BreadcrumbDataProps> = ({ breadcrumbs }) => {
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.map((breadcrumb, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        name: breadcrumb.label,
        item: `${Config.baseUrl}${routeToHref(breadcrumb.route)}`,
      })),
    },
  ]
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtmlWithFilter(JSON.stringify(structuredData)),
        }}
      />
    </Head>
  )
}

export default BreadcrumbData
